// extracted by mini-css-extract-plugin
module.exports = {"loadWrapper":"ModalMap_loadWrapper__266YA","wrongAdressWrapper":"ModalMap_wrongAdressWrapper__8O9mX","map":"ModalMap_map__1VYzE"};